module.exports = __webpack_public_path__ + "static/img/01@2x.770a0fd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/01@2x.png
// module id = vHwK
// module chunks = 1